class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)
    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, `click`, this.handleTrigger)
    })

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)

    this.externalEls?.trigger?.elements.forEach((externalTriggerEl) => {
      this.listeners.add(
        externalTriggerEl,
        'click',
        this.handleExternalTrigger,
      )
    })
  }

  handleTrigger (event) {
    const itemEl = event.target.closest(this.els?.item?.selector)
    if (!itemEl) return

    if (this.dataset.type === 'oneopen') {
      this.els?.item?.elements.forEach((tempEl) => {
        if (tempEl !== itemEl) {
          tempEl.setAttribute('aria-expanded', 'false')
        }
      })
    }

    const currentState = itemEl.getAttribute('aria-expanded') === 'true'
    itemEl.setAttribute('aria-expanded', !currentState)
  }

  handleExternalTrigger (event) {
    const toTrigger = event.target.dataset.toTrigger
    if (!toTrigger) return

    const reopenTarget =
      event.target.dataset.reopenTarget === 'true' &&
      window.BAO.MediaBreakpoints.isMd === true

    const targetItem = this.els.item.elements.find(
      (itemEl) => itemEl.dataset.triggerId === toTrigger,
    )

    if (!targetItem) return

    if (reopenTarget && targetItem.getAttribute('aria-expanded') === 'true') {
      targetItem.setAttribute('aria-expanded', 'false')

      targetItem.addEventListener(
        'transitionend',
        () => {
          targetItem.setAttribute('aria-expanded', 'true')
        },
        { once: true },
      )
    } else {
      targetItem.setAttribute('aria-expanded', 'true')
    }

    if (this.dataset.type === 'oneopen') {
      this.els.item.elements.forEach((itemEl) => {
        if (itemEl !== targetItem) {
          itemEl.setAttribute('aria-expanded', 'false')
        }
      })
    }
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
